import type { GridValueFormatterParams } from "@mui/x-data-grid";
import { formatDate } from "util/formaters";

const dateTime = ({ value }: GridValueFormatterParams<string>) =>
    formatDate(value, { pattern: 'D MMM YYYY, H:mm' });

export default dateTime;
